<template>
	<div style="overflow-y: hidden" class="font-family">
		<!-- Start Loader -->
		<div class="section-loader" style="display: none;">
		<div class="loader">
			<div></div>
			<div></div>
		</div>
		</div>
		<!-- End Loader -->

		<!-- =================== 导航 =================== -->
		<header class="black-bg mh-header mh-fixed-nav nav-scroll mh-xs-mobile-nav" id="mh-header">
			<navigation></navigation>
		</header>

		<!-- =================== 首页  =================== -->
		<section class="mh-home image-bg home-2-img" id="mh-home">
			<home></home>
		</section>

		<!-- =================== 关于 =================== -->
		<section class="mh-about" id="mh-about" name="mh-about">
			<about></about>
		</section>

		<!-- =================== 技能 =================== -->
		<section class="mh-skills image-bg home-2-img" id="mh-skills">
			<skill></skill>
		</section>

		<!-- =================== 服务 =================== -->
		<section class="mh-service">
			<service></service>
		</section>

		<!-- =================== 经验 =================== -->
		<section class="mh-experince image-bg featured-img-one" id="mh-experience">
			<experience></experience>
		</section>

		<!-- =================== 作品 =================== -->
		<!-- <section class="mh-portfolio" id="mh-portfolio">
			<portfolio></portfolio>
		</section> -->

		<!-- =================== 合作 =================== -->
		<section class="mh-quates">
			<quates></quates>
		</section>

		<!-- =================== 项目 =================== -->
		<section class="mh-featured-project image-bg featured-img-one" id="mh-project">
			<project></project>
		</section>

		<!-- =================== 博客 ===================  -->
		<section class="mh-blog image-bg featured-img-two" id="mh-blog">
			<blog></blog>
		</section>

        <!-- =================== 友情链接 ===================  -->
		<section class="mh-blog image-bg featured-img-two" id="mh-blog">
			<friendship-link></friendship-link>
		</section>

		<!-- =================== 评价 =================== -->
		<!-- <section class="mh-testimonial" id="mh-testimonial">
			<testimonial></testimonial>
		</section> -->

		<!-- =================== 联系 =================== -->
		<footer class="mh-footer mh-footer-3" id="mh-contact">
			<contact></contact>
		</footer>

        <!-- =================== 设置 =================== -->
		<setting></setting>

	</div>
</template>
<script>
import Navigation from '@/components/Navigation.vue'
import Home from '@/components/Home.vue'
import About from '@/components/About.vue'
import Service from '@/components/Service.vue'
import Project from '@/components/Project.vue'
import Skill from '@/components/Skill.vue'
import Experience from '@/components/Experience.vue'
import Portfolio from '@/components/Portfolio.vue'
import Quates from '@/components/Quates.vue'
import Blog from '@/components/Blog.vue'
import Testimonial from '@/components/Testimonial.vue'
import Contact from '@/components/Contact.vue'
import Setting from '@/components/Setting.vue'
import FriendshipLink from '@/components/FriendshipLink.vue'
export default {
  data() {
    return {
      
    };
  },
  components: { Navigation, Home, About, Service, Project, Skill, Experience, Portfolio, Quates, Blog, Testimonial, Contact, Setting, FriendshipLink },
  created() {},
  mounted() {
    $("selector").click(function () {
      $("selector.active").removeClass("active");
      $(this).addClass("active");
    });
  },
  computed: {},
  watch: {},
  methods: {
    
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/home/Home.vue